import React from 'react'
import { withRouter } from 'react-router-dom'
import qs from 'query-string'
import flow from 'lodash.flow'
import merge from 'lodash.merge'

const withQueryParams = Component => props => {
  const search = props?.location?.search ?? null

  if (!search) return <Component {...merge(props, { params: {} })} />

  try {
    const params = qs.parse(search)
    return <Component {...merge(props, { params })} />
  } catch (e) {
    return <Component {...merge(props, { params: {} })} />
  }
}

export default flow(withRouter, withQueryParams)
